(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 38318:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(38437);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 38437:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AboutPage; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/Layout/Layout.tsx + 22 modules
var Layout = __webpack_require__(4828);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/Pages/About/About.tsx



const About = (param)=>{
    let {} = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mb-10",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/images/michal-profile-photo-1.jpg",
                    width: 180,
                    height: 180,
                    className: "rounded-full",
                    alt: "Michal's profile photo"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: "text-4xl tracking-tight font-extrabold text-gray-900 sm:text-5xl md:text-5xl",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "block xl:inline",
                        children: "Hey, I'm Michal \uD83D\uDC4B"
                    }),
                    " "
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl",
                children: "I am the founder, engineer, designer and customer support of JobsinJS."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl",
                children: "Over the years of being a software engineer I realised that while there are many great jobs out there, they are not always easy to find."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl",
                children: "My goal with this website is to surface the best JS jobs and companies and make it easy for you to find them."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                className: "mt-3 max-w-md mx-auto text-base sm:text-lg md:mt-5 md:text-xl md:max-w-3xl",
                children: [
                    "You can reach me on",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://twitter.com/michalmalota",
                        className: "text-blue-600",
                        children: "Twitter"
                    }),
                    " ",
                    "or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "https://www.linkedin.com/in/michalmalota/",
                        className: "text-blue-600",
                        children: "Linkedin"
                    }),
                    " ",
                    "or email me at",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        href: "mailto:michal@jobsinjs.com",
                        className: "text-blue-600",
                        children: "michal@jobsinjs.com"
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/about/index.tsx



function AboutPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* Layout */.A, {
        pageTitle: "About",
        metaDescription: "Hello, I'm Michal \uD83D\uDC4B I am the founder, engineer, designer and customer support of Jobs in JS.",
        bodyCN: "px-4",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "max-w-4xl m-auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "pt-10 pb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {})
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1664,8184,5675,4828,9774,2888,179], function() { return __webpack_exec__(38318); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);